// ---------------------------------------------------------------------------
// What counts as a plan EDIT. Two surfaces answer "did the plan change?" — the
// Save button's dirty state (`unsavedPlanChanges`) and the Save review's rows
// (`diffSchedule`) — and they must agree, or Save lights with nothing to
// review (or the review lists rows nobody edited). Both read records through
// this one lens.
// ---------------------------------------------------------------------------

/**
 * Fields a plan record carries that are VIEW state, not plan: a summary task's
 * or a group's fold. They ride the store (folding is undoable) and the save
 * payload, but the server does not keep them, so folding is never an edit.
 */
export const VIEW_ONLY_FIELDS: ReadonlySet<string> = new Set(['collapsed']);

/**
 * Absent, `''`, `null`, `false` and `[]` all mean "unset" on a plan field: the
 * drawer stores `notes: ''` where an import has no `notes` key, a top-level
 * task may carry `parentId: null` or none. Collapsed to `undefined` so the two
 * spellings of "nothing" compare equal.
 */
export function unsetToUndefined<T>(value: T): T | undefined {
  if (value === '' || value === null || value === false) return undefined;
  if (Array.isArray(value) && value.length === 0) return undefined;
  return value;
}

/** A plan record reduced to what an edit can change: view-only fields dropped,
 *  unset values collapsed to `undefined` (which `sameJson` reads as absent). */
export function planFields(record: object): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(record)
      .filter(([key]) => !VIEW_ONLY_FIELDS.has(key))
      .map(([key, value]) => [key, unsetToUndefined(value)]),
  );
}
